import { render } from "./BlckSection.vue?vue&type=template&id=05852a8a"
import script from "./BlckSection.vue?vue&type=script&lang=js"
export * from "./BlckSection.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__